import { Badge } from "@deere/fuel-react";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { TFunction } from "i18next";
import { getD2DRejectStatusLabelKey } from "../utils/rejectionStatus";

interface D2DStatusMetadata {
  lastChangedBy?: string;
  rejectionType?: string | null;
  rejectionTrigger?: string | null;
}

export const getStatusBadge = (
  status: string,
  t: TFunction<["d2d", "common"], undefined>,
  metadata?: D2DStatusMetadata
) => {
  switch (status) {
    case "NEW":
      return (
        <Badge
          startIcon={<DirectionsRunIcon />}
          variant="info"
          data-testid="d2d-order-status-badge"
        >
          {t("d2d:status.requested")}
        </Badge>
      );
    case "ACCEPTED":
      return (
        <Badge
          startIcon={<CheckCircleIcon />}
          variant="success"
          data-testid="d2d-order-status-badge"
        >
          {t("d2d:status.accepted")}
        </Badge>
      );
    case "REJECTED": {
      const rejectStatusKey =
        getD2DRejectStatusLabelKey({
          status,
          lastChangedBy: metadata?.lastChangedBy,
          rejectionType: metadata?.rejectionType,
          rejectionTrigger: metadata?.rejectionTrigger,
        }) ?? "d2d:status.manualRejected";
      return (
        <Badge
          startIcon={<CancelIcon />}
          variant="error"
          data-testid="d2d-order-status-badge"
        >
          {t(rejectStatusKey)}
        </Badge>
      );
    }
    case "EXPIRED":
      return (
        <Badge
          startIcon={<WarningAmberIcon />}
          variant="warning"
          data-testid="d2d-order-status-badge"
        >
          {t("d2d:status.expired")}
        </Badge>
      );
    case "SHIPPED":
      return (
        <Badge
          startIcon={<LocalShippingIcon />}
          variant="success"
          data-testid="d2d-order-status-badge"
        >
          {t("d2d:status.shipped")}
        </Badge>
      );
    case "COMPLETED":
      return (
        <Badge
          startIcon={<CheckCircleIcon />}
          variant="success"
          data-testid="d2d-order-status-badge"
        >
          {t("d2d:status.completed")}
        </Badge>
      );
    case "CREDITED":
      return (
        <Badge
          startIcon={<CheckCircleIcon />}
          variant="success"
          data-testid="d2d-order-status-badge"
        >
          {t("d2d:status.credited")}
        </Badge>
      );
    default:
      return <Badge variant="info">{status}</Badge>;
  }
};
